export enum CustomerEmployeeAccessLevel {
    none = 1,
    reporter,
    fullAccess
}

export const getIssueCustomerEmployeeAccessLevelNameRu = (lvl: CustomerEmployeeAccessLevel) => {
    switch (lvl) {
        case CustomerEmployeeAccessLevel.none: return 'Без доступа';
        case CustomerEmployeeAccessLevel.reporter: return 'Заявитель';
        case CustomerEmployeeAccessLevel.fullAccess: return 'Полный доступ';
        default: return 'неизвестен';
    }
}